import { render, staticRenderFns } from "./PromotionList.vue?vue&type=template&id=62c7c31b&scoped=true"
import script from "./PromotionList.vue?vue&type=script&lang=js"
export * from "./PromotionList.vue?vue&type=script&lang=js"
import style0 from "./PromotionList.vue?vue&type=style&index=0&id=62c7c31b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c7c31b",
  null
  
)

export default component.exports